// eslint-disable-next-line import/prefer-default-export
export const maxPoints = {
  basic: {
    scoreResponse: 40,
    scoreTarget: 10,
    scoreContent: 10,
    scoreApproach: 10,
    scoreProcess: 10,
    scoreQuantityAndQuality: 50,
    scoreApplicationProduct: 5,
    scorePublishedProduct: 30,
    scoreTrainingProduct: 15,
    scoreReportQuality: 10,
  },
  applied: {
    scoreResponse: 40,
    scoreTarget: 10,
    scoreContent: 10,
    scoreApproach: 10,
    scoreProcess: 10,
    scoreQuantityAndQuality: 50,
    scoreApplicationProduct: 30,
    scorePublishedProduct: 10,
    scoreTrainingProduct: 10,
    scoreReportQuality: 10,
  },
  implementation: {
    scoreResponse: 40,
    scoreTarget: 10,
    scoreContent: 10,
    scoreApproach: 10,
    scoreProcess: 10,
    scoreQuantityAndQuality: 50,
    scoreApplicationProduct: 40,
    scorePublishedProduct: 5,
    scoreTrainingProduct: 5,
    scoreReportQuality: 10,
  },
};
